import React from 'react'

import { cookieBannerText } from '../constants/cookie-banner-text'

interface CookieBannerProps {
  isVisible: boolean
  onAcceptAll: () => void
  onRejectAll: () => void
  onOpenSettings: () => void
}

export const CookieBanner: React.FC<CookieBannerProps> = ({ isVisible, onAcceptAll, onRejectAll, onOpenSettings }) => {
  if (!isVisible) return null

  return (
    <div className="fixed bottom-4 left-4 z-[205] max-w-sm">
      <div className="bg-white bg-opacity-95 backdrop-blur-sm border border-gray-200 rounded-lg shadow-lg p-4">
        <h3 className="font-semibold text-gray-900 mb-2">{cookieBannerText.title}</h3>
        <p className="text-sm text-gray-600 mb-4 leading-relaxed">
          {cookieBannerText.description}{' '}
          <a
            href={cookieBannerText.privacyPolicy.url}
            className="text-orange500 hover:text-orange600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {cookieBannerText.privacyPolicy.label}
          </a>
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={onAcceptAll}
            className="w-full px-4 py-2 bg-orange-500 text-white text-sm rounded-md hover:bg-orange600 transition-colors"
          >
            {cookieBannerText.buttons.acceptAll}
          </button>
          <button
            onClick={onRejectAll}
            className="w-full px-4 py-2 border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50 transition-colors"
          >
            {cookieBannerText.buttons.rejectAll}
          </button>
          <button
            onClick={onOpenSettings}
            className="w-full px-4 py-2 text-gray-600 text-sm rounded-md hover:bg-gray-100 transition-colors underline"
          >
            {cookieBannerText.buttons.settings}
          </button>
        </div>
      </div>
    </div>
  )
}
